import React, {useEffect, useState} from 'react';
import {Button, Col, Modal} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {Redirect} from "react-router-dom";
import {resource_strings} from "../../translations/resource_translations";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const NotProModal = (props) => {
    const [visible, setVisible] = useState(props.showNotProModal === true);
    const [goToSubscriptions, setToSubscriptions] = useState(false);

    useEffect(() => {
        if (props.showNotProModal !== visible) {
            setVisible(props.showNotProModal === true)
        }
    });

    function toggle(formModal) {
        props.toggleNotProModal();
    }

    function toSubscription() {
        setToSubscriptions(true)
    }

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    localize();

    if (goToSubscriptions === true) {
        return <Redirect from="/" to="/admin/subscriptions"/>
    } else return (
        <Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={visible}
            toggle={() => toggle("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => toggle("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <img
                        alt="..."
                        width={64}
                        src={require("assets/img/brand/open-white-logo.png")}/>
                    <h3 className="mt-4 text-white">{alertStrings.pro_functionality}</h3>
                    <p>
                        {alertStrings.not_pro_expl}
                    </p>

                    {props.description &&
                    <>
                        <h4 className="text-white mt-2">
                            {resourceStrings.subscriptions.your_current_plan}:
                        </h4>
                        <p>
                            {props.description}
                        </p>
                    </>
                    }
                </div>
            </div>
            <div className="modal-footer">
                <Col className="text-center">
                    <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                            onClick={toSubscription}>
                        {resourceStrings.subscriptions.subscriptions}
                    </Button>

                    <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                            onClick={toggle}
                    >
                        {commonStrings.close}
                    </Button>

                </Col>
            </div>
        </Modal>
    );
};

export default NotProModal;